import axios from 'axios'

export const passwordChecker = axios.create({
	baseURL: 'https://outros-n8n.y0nyoi.easypanel.host/webhook/strong-password-check'
})